import type { ProvidersMap } from './types';

export const buildEmptyProvidersMap = (provider: any): ProvidersMap => {
    return Object.fromEntries(
        provider?.requiresSubProvider
            ? provider.subProviderData.map(
                  (data: { providerName: string; providerArn: string }) => [
                      data.providerName,
                      {
                          arn: data.providerArn,
                          studentSubListValue: '',
                          capacity: 0,
                          studentCount: 0,
                      },
                  ],
              )
            : [
                  [
                      provider?.name,
                      {
                          arn: provider?.arn,
                          studentSubListValue: '',
                          capacity: 0,
                          studentCount: 0,
                      },
                  ],
              ],
    );
};
